// In plugins/fancybox.js
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

Fancybox.bind('[data-fancybox]', {
    Thumbs: {
        autoStart: false,
    },
    Toolbar: {
        display: {
            left: [],
            middle: [],
            right: ["close"],
        },
    },
});

export default {
    install: (app) => {
        app.config.globalProperties.$fancybox = Fancybox;
    },
};